import {
    InputType,
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from '@fitogest/reactive-form-builder/interfaces';
import { ProductosModel } from 'src/app/models/productos/productos.model';

import { ProductosFitosanitariosEnvironmentDefinition } from '../environment-variables';

export class ProductosFitosanitariosListFormDefinition {
    public env: ProductosFitosanitariosEnvironmentDefinition = new ProductosFitosanitariosEnvironmentDefinition();

    public formType!: FormType;

    public model: Partial<ProductosModel> = {};

    public formFields!: Form<ProductosModel>;

    public fieldNames: FormField<ProductosModel>[] = [];

    public fieldLabels: string[] = [];

    constructor(type: FormType = FormType.INFORMATIVE, model: Partial<ProductosModel> = {}) {
        this.formType = +type;
        this.model = model;

        this.formFields = {
            name: 'producto-fitosanitario-list',
            header: 'Datos del Producto',
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    private getFormSections(): FormSection<ProductosModel>[] {
        return [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getMainFields(),
                order: 1,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getCommercialFields(),
                order: 2,
            },
        ];
    }

    private getMainFields(): FormField<ProductosModel>[] {
        const fields: FormField<ProductosModel>[] = [
            this.textField('num_registro', 'Referencia', 1),
            this.textField('nombre', 'Nombre', 2),
            this.textField('ps', 'Plazo Seguridad', 3),
            this.textField('materia_activa', 'Materia Activa', 4),
            {
                name: 'otra_denominacion_comun',
                label: 'Otra denominación común',
                input: {
                    type: InputType.SWITCH,
                    isEditable: false,
                },
                width: 4,
                conditions: this.conditions(),
                order: 5,
            },
        ];

        return this.registerVisibleFields(fields);
    }

    private getCommercialFields(): FormField<ProductosModel>[] {
        const fields: FormField<ProductosModel>[] = [
            this.textField('precio', this.env.appName === 'agrotata' ? 'Precio Coste' : 'Precio', 1),
            this.textField('precio_venta', 'Precio de Venta', 2, this.env.appName === 'agrotata'),
            this.textField('familia', 'Familia', 3, this.env.appName === 'agroleza'),
            this.textField('unidades', 'Uds medida', 4),
            this.textField('envase', 'Envase', 5),
            this.textField('dosis', 'Dosis', 6, this.env.showProductosFitoDosis),
            this.textField('num_maximo_aplicaciones', 'Nº Máximo aplicaciones', 7, this.env.showProductosMaxAplicacion),
            this.textField('observaciones', 'Observaciones', 8, this.env.appName === 'amoros'),
        ];

        return this.registerVisibleFields(fields);
    }

    private textField(name: string, label: string, order: number, isVisible = true): FormField<ProductosModel> {
        return {
            name,
            label,
            input: {
                type: InputType.ONLY_TEXT,
                isEditable: false,
            },
            width: 4,
            conditions: this.conditions({ isVisible }),
            order,
        };
    }

    private registerVisibleFields(fields: FormField<ProductosModel>[]): FormField<ProductosModel>[] {
        for (const field of fields) {
            if (field.conditions.isVisible) {
                this.fieldNames.push(field);
                this.fieldLabels.push(field.label);
            }
        }

        return fields.sort((a, b) => a.order - b.order);
    }

    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: false,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }
}

export class ProductosSdiListFormDefinition {
    public formType!: FormType;

    public model: Partial<ProductosModel> = {};

    public formFields!: Form<ProductosModel>;

    constructor(type: FormType = FormType.INFORMATIVE, model: Partial<ProductosModel> = {}) {
        this.formType = +type;
        this.model = model;

        this.formFields = {
            name: 'producto-sdi-list',
            header: 'Detalle del registro',
            type: this.formType,
            sections: [
                {
                    name: '',
                    width: 12,
                    isVisible: true,
                    fields: this.getFields(),
                    order: 1,
                },
            ],
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    private getFields(): FormField<ProductosModel>[] {
        return [
            this.textField('codart', 'Código', 1),
            this.textField('descart', 'Descripción', 2),
            this.textField('prcventa', 'Precio de venta', 3),
            this.textField('sdifit_numregistro', 'Número de registro', 4),
            this.textField('sdifit_composicion', 'Composición', 5),
            this.textField('sdifit_tipoproducto', 'Tipo de producto', 6),
            this.textField('sdiadr_nombre', 'Nombre', 7),
            this.textField('texto', 'Texto', 8),
            this.textField('sdifit_nombrecomercial', 'Nombre comercial', 9),
        ];
    }

    private textField(name: string, label: string, order: number): FormField<ProductosModel> {
        return {
            name,
            label,
            input: {
                type: InputType.ONLY_TEXT,
                isEditable: false,
            },
            width: 4,
            conditions: {
                isRememberedOnDuplicate: false,
                isRequired: false,
                isRetained: false,
                hasUndoEnabled: false,
                isVisible: true,
            },
            order,
        };
    }
}
